import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import moment from "moment";
import { Typography } from "@progress/kendo-react-common";
import ShadowCard from "../../../components/common/ShadowCard";
import {
  clearSalesManWiseReportDetails,
  clearSalesManWiseReportList,
  setSalesManWiseReport,
} from "../reportsSlice";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { getSalesManWiseReportReport } from "../services/reports.services";
import FormDatePicker from "../../../components/formFields/FormDateField";
import { getAllSalesRepresentative } from "../../salesrepresentativeassign/services/salesRepresentative.services";
import { requiredValidator } from "../../../components/formFields/CommonValidator";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const ChangeWatcher = ({ formRenderProps }: FormChangeWatcherProps) => {
  useEffect(() => {
    formRenderProps.onChange("department_id", {
      value: null,
    });
  }, []);
  return null;
};

const DSRReportForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);
  const DSRReportDetails = useAppSelector(
    (state) => state.reports.DSRReportDetails
  );

  const SalesRepresentativeList = useAppSelector(
    (state) => state.salesrepresentative.SalesRepresentativeList
  );

  //   const currentPage = useAppSelector((state) => state.pagination.currentPage);
  //   const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    dispatch(getAllSalesRepresentative());
    return () => {
      dispatch(clearSalesManWiseReportDetails());
      dispatch(clearSalesManWiseReportList());
    };
  }, []);

  // const item_category = "Chilli Powder";
  // const product_name = "Chilli Powder Rs.10";

  const handleSubmit = (values: any) => {
    const payload = {
      report_date: values?.report_date
        ? moment(values?.report_date).format("YYYY-MM-DD")
        : "",
      sr_id: values?.sr_id,
      //   limit: +pageLimit,
      //   skip: +currentPage * +pageLimit,
    };
    sessionStorage.setItem("dsrreportState", JSON.stringify(payload));
    const reportTab = window.open("/dsrreportprint", "_blank");
    const interval = setInterval(() => {
      if (reportTab?.closed) {
        sessionStorage.removeItem("dsrreportState");
        clearInterval(interval);
      }
    }, 1000);

    dispatch(getSalesManWiseReportReport(payload));
    dispatch(setSalesManWiseReport(payload));
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            initialValues={DSRReportDetails}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <ChangeWatcher formRenderProps={formRenderProps} />
                  <GridLayoutItem colSpan={4}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      SR Monthly Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="report_date"
                      label="Report Date"
                      format={"dd/MM/yyyy"}
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="sr_id"
                      label="Sales Representative"
                      placeholder="Select Sales Representative"
                      component={FormSelectionField}
                      astrike={true}
                      validator={requiredValidator}
                      options={SalesRepresentativeList.map((emp: any) => ({
                        value: emp.id,
                        label: `${emp?.first_name} ${emp?.middle_name} ${emp?.last_name}`,
                      }))}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <div style={{ marginTop: "35px" }}>
                      <ButtonWithLoading
                        label={"View"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </ShadowCard>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default DSRReportForm;
